import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  lookup: {}
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
